export * from "./AvatarCircle";
export { default as AvatarCircleWithCache } from "./AvatarCircleWithCache";

export const getAvatarColorIndex = (str: string): number => {
   const code = Array.from(str).reduce(
      (s, c) => (Math.imul(31, s) + c.charCodeAt(0)) | 0,
      0
   );

   return Math.abs(code);
};
